import { z } from "zod";
export const ClientWorkspaceNextActionHomeV1Schema = z.object({ schemaVersion: z.literal("client-workspace-next-action-home.v1.0"), requirementId: z.literal("CW-003"), ok: z.boolean() }).strict();
//# sourceMappingURL=client-workspace-next-action-home.js.map